import { SaleCreateErrorCode } from '../models/sale.constants'
import { Sale } from '../models/sale'

export class OverwritingSaleError extends Error {
  public sale: Sale
  public code: SaleCreateErrorCode

  constructor(message: string, sale: Sale) {
    super(message)
    this.sale = sale
    this.code = SaleCreateErrorCode.EXISTS
  }
}
